import User from './User'
import Image from './Image'
import Reports from './Reports'
import Team from './Team'
import Company from './Company'
import Mission from './Mission'
import Items from './Items'
import Template from './Template'
import Affiliation from './Affiliation'
import Proovers from './Proovers'
import Webhooks from './Webhooks'

export default {
  user: new User(),
  image: new Image(),
  reports: new Reports(),
  team: new Team(),
  company: new Company(),
  missions: new Mission(),
  templates: new Template(),
  items: new Items(),
  proovers: new Proovers(),
  webhooks: new Webhooks(),
  affiliation: new Affiliation()
}
